import { EventEmitter } from '@angular/core';
import { listOrderedPlatforms } from '../../../../app.constants';
import { InfluencerSuggestion, InfluencerSuggestionState } from '../../../../../models/influencer-suggestion';
var StatusInfluencerSuggestionComponent = /** @class */ (function () {
    function StatusInfluencerSuggestionComponent() {
        this.addNewInfluencerManuallyEvent = new EventEmitter();
        this.showMultipleSelectionEvent = new EventEmitter();
        this.retryAfterErrorEvent = new EventEmitter();
        this.platformList = [];
    }
    StatusInfluencerSuggestionComponent.prototype.ngOnInit = function () {
        this.platformList = listOrderedPlatforms;
    };
    Object.defineProperty(StatusInfluencerSuggestionComponent.prototype, "isUnknownInfluencer", {
        get: function () {
            return this.influencer.state === InfluencerSuggestionState.NOT_FOUND;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusInfluencerSuggestionComponent.prototype, "isProcessing", {
        get: function () {
            return this.influencer.state === InfluencerSuggestionState.PROCESSING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusInfluencerSuggestionComponent.prototype, "isMultiple", {
        get: function () {
            return this.influencer.state === InfluencerSuggestionState.MULTIPLE_SUGGESTIONS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusInfluencerSuggestionComponent.prototype, "hasError", {
        get: function () {
            return this.influencer.state === InfluencerSuggestionState.ERROR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusInfluencerSuggestionComponent.prototype, "isSingle", {
        get: function () {
            return this.influencer.state === InfluencerSuggestionState.SINGLE_SUGGESTION;
        },
        enumerable: true,
        configurable: true
    });
    StatusInfluencerSuggestionComponent.prototype.addNewInfluencer = function () {
        this.addNewInfluencerManuallyEvent.emit({
            handle: this.handle,
            index: this.index,
            influencer: this.influencer
        });
    };
    StatusInfluencerSuggestionComponent.prototype.hasPlatform = function (platformId, influencer) {
        if (!influencer.channels) {
            return false;
        }
        return influencer.channels.findIndex(function (channel) {
            if (channel.platform) {
                return channel.platform.id === platformId;
            }
            else {
                return channel.platform_id === platformId;
            }
        }) >= 0;
    };
    StatusInfluencerSuggestionComponent.prototype.openMultipleSelection = function () {
        this.showMultipleSelectionEvent.emit(this.handle);
    };
    StatusInfluencerSuggestionComponent.prototype.retryAddInfluencer = function () {
        this.retryAfterErrorEvent.emit({
            index: this.index,
            influencer: this.influencer
        });
    };
    return StatusInfluencerSuggestionComponent;
}());
export { StatusInfluencerSuggestionComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencer-group/status-influencer-suggestion/status-influencer-suggestion.component.ts.pre-build-optimizer.js